var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "registration-button",
      class: { "registration-button--active": _vm.isActive },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.$emit("click")
        },
        submit: function($event) {
          $event.preventDefault()
          return _vm.$emit("click")
        }
      }
    },
    [
      _vm._t("default", function() {
        return [_vm._v(_vm._s(_vm.text))]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19ae31fb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19ae31fb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegistrationButton.vue
// module id = null
// module chunks = 